import { Model } from "@singularsystems/neo-core";
import { NeoGrid } from "@singularsystems/neo-react";
import { CatalogueEntry } from "../CatalogueEntry";
import DataCache from "../../../Services/DataCache";
import * as CatalogueRoles from "../../../Models/Security/CatalogueRoles"
import { IGenericApiClient } from "../../../ApiClients/Catalogues/GenericApiClient";
import { Catalogue } from "@singularsystems/neo-react-services";
import DwtExemption from "../../../Models/Catalogue/General/DwtExemption";

export default class DwtExemptionCatalogueEntry extends CatalogueEntry<DwtExemption> {

    constructor() {
        super("DWT Exemptions", DwtExemption);
    }

    public get editRole() {
        return CatalogueRoles.DwtExemption.Edit;
    }

    public getCacheEntry(cache: DataCache) {
        return cache.dwtExemptions;
    }

    public getSaveEndpoint(apiClient: IGenericApiClient) {
        return apiClient.saveDwtExemptions;
    }

    public renderRow(item: DwtExemption, meta: Model.TransformMetaType<DwtExemption>) {
        return (
            <NeoGrid.Row>
                <NeoGrid.Column bind={meta.code} />
                <NeoGrid.Column bind={meta.description} />
                <Catalogue.ButtonColumn />
            </NeoGrid.Row>
        )
    }
}